import { Controller } from 'react-hook-form';
import { Radio } from '@paysera/ui';
const RadioField = ({ name, label, options, control, onAfterChange }) => (<Controller name={name} control={control} render={({ field: controllerField }) => (<div>
                <label className="block mb-2 label-m">{label}</label>
                <div className="flex flex-col gap-2">
                    {options.map((option) => (<Radio key={option.value} name={name} value={option.value} checked={String(controllerField.value) === option.value} onChange={() => {
                controllerField.onChange(option.value);
                onAfterChange();
            }} label={option.label}/>))}
                </div>
            </div>)}/>);
export default RadioField;
